import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";
import type { DepartmentWageDataResponse } from "../utils/models";

export const useDepartmentWageData = (departmentId: string, wantDate: string) => {
	return useQuery<DepartmentWageDataResponse>({
		queryKey: ["department-wage-data", departmentId, wantDate],
		queryFn: async () => {
			const response = await backendService.getDepartmentWageData(departmentId, wantDate);
			return response.data;
		},
		enabled: false,
	});
};
